import Fetchers from 'core/fetchers';
import ApplicationController from '../application_controller'

export default class FavoriteController extends ApplicationController {
  static values = {
    addIconPath: String,
    removeIconPath: String,
  }

  redirectSignUpPage(event) {
    this.redirectToSignUp(event)
  }

  redirectToSignUp(event) {
    const { designId, productId, redirectRoute } = event.currentTarget.dataset;
    if (!redirectRoute) return;

    event.preventDefault();
    window.location = `${redirectRoute}?favorite_design_id=${designId}&favorite_product_id=${productId}`;
  }

  handleTouch(event) {
    this.redirectToSignUp(event)
  }

  favoriteButtonURL(action) {
    return `/account/${action}_favorite_design`;
  }

  toggleFavorite(event) {
    const currentTarget = event.currentTarget;

    // Prevent double clicks by disabling the button
    if (currentTarget.disabled) return;
    currentTarget.disabled = true;
    currentTarget.classList.add('tp-favorite-button--inactive');

    const url = this.favoriteButtonURL(currentTarget.dataset.buttonAction);
    const body = JSON.stringify({
      design_id: currentTarget.dataset.designId,
      product_id: currentTarget.dataset.productId,
    });

    Fetchers.fetchJSON(url, 'POST', body)
      .then(res => res.json())
      .then((data) => {
        this.updateFavoriteButton(currentTarget, data)
        this.displaySuccessMessage(data.message);
      })
      .catch(error => console.log(error))
      .finally(() => {
        // Re-enable the button after the request completes
        currentTarget.disabled = false;
        currentTarget.classList.remove('tp-favorite-button--inactive');
      });
  }

  updateFavoriteButton(target, data) {
    const imgTag = target.querySelector('img');
    let newFilterOptionLabel,
        newModifierClass;

    if (data.new_action === 'add') {
      newFilterOptionLabel = 'add_to_favorites';
      newModifierClass = 'tp-favorite-button--unfilled';
      imgTag.src = this.addIconPathValue;
    } else if (data.new_action === 'remove') {
      newFilterOptionLabel = 'remove_from_favorites';
      newModifierClass = 'tp-favorite-button--filled';
      imgTag.src = this.removeIconPathValue;
    }

    target.classList.forEach(className => {
      // remove modifier class
      if (className.includes('tp-favorite-button--')) target.classList.remove(className);
    });

    target.dataset.buttonAction = data.new_action;
    target.dataset.filterOptionLabel = newFilterOptionLabel;
    target.classList.add(newModifierClass);

    target.blur();
  }

  displaySuccessMessage(message) {
    const pastMessage = document.querySelector('.jsFavoriteMessage');
    const node = new DOMParser().parseFromString(message, "text/html").body.firstElementChild;

    if (pastMessage) pastMessage.remove();

    document.querySelector('body').appendChild(node);

    setTimeout(() => {
      node.remove();
    }, 4000);
  }
}
